export enum FeatureStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export enum FeatureAction {
  CREATE = "CREATE",
  CREATE_BULK = "CREATE_BULK",
  READ = "READ",
  READ_BULK = "READ_BULK",
  EDIT = "EDIT",
  EDIT_BULK = "EDIT_BULK",
  DELETE = "DELETE",
  DELETE_BULK = "DELETE_BULK",
  EXPORT = "EXPORT",
  IMPORT = "IMPORT",
  ADD = "ADD",
  REMOVE = "REMOVE",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  APPROVE = "APPROVE",
  REJECT = "REJECT",
  READ_BULK_SHORT = "READ_BULK_SHORT",
  CLONE = "CLONE",
  DOWNLOAD = "DOWNLOAD",
}

export enum FeatureShortAction {
  CREATE = "c",
  CREATE_BULK = "cb",
  READ = "r",
  READ_BULK = "rb",
  EDIT = "e",
  EDIT_BULK = "eb",
  DELETE = "d",
  DELETE_BULK = "db",
  EXPORT = "ex",
  IMPORT = "im",
  ADD = "ad",
  REMOVE = "rm",
  ACTIVE = "ac",
  INACTIVE = "in",
  APPROVE = "ap",
  REJECT = "rj",
  READ_BULK_SHORT = "rbs",
  CLONE = "cl",
  DOWNLOAD = "dl",
}

export const FeatureShortActionObject: Record<string, string> = {
  CREATE: "c",
  CREATE_BULK: "cb",
  READ: "r",
  READ_BULK: "rb",
  EDIT: "e",
  EDIT_BULK: "eb",
  DELETE: "d",
  DELETE_BULK: "db",
  EXPORT: "ex",
  IMPORT: "im",
  ADD: "ad",
  REMOVE: "rm",
  ACTIVE: "ac",
  INACTIVE: "in",
  APPROVE: "ap",
  REJECT: "rj",
  READ_BULK_SHORT: "rbs",
  CLONE: "cl",
  DOWNLOAD: "dl",
};

export const FeatureStatusOptions = [
  {
    label: "Active",
    value: FeatureStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: FeatureStatus.INACTIVE,
  },
];

export const FeatureActionOptions = [
  {
    label: "Create",
    value: FeatureAction.CREATE,
  },
  {
    label: "Create Bulk",
    value: FeatureAction.CREATE_BULK,
  },
  {
    label: "Read",
    value: FeatureAction.READ,
  },
  {
    label: "Read Bulk",
    value: FeatureAction.READ_BULK,
  },
  {
    label: "Read Bulk Short",
    value: FeatureAction.READ_BULK_SHORT,
  },
  {
    label: "Edit",
    value: FeatureAction.EDIT,
  },
  {
    label: "Edit Bulk",
    value: FeatureAction.EDIT_BULK,
  },
  {
    label: "Delete",
    value: FeatureAction.DELETE,
  },
  {
    label: "Delete Bulk",
    value: FeatureAction.DELETE_BULK,
  },
  {
    label: "Export",
    value: FeatureAction.EXPORT,
  },
  {
    label: "Import",
    value: FeatureAction.IMPORT,
  },
  {
    label: "Add",
    value: FeatureAction.ADD,
  },
  {
    label: "Remove",
    value: FeatureAction.REMOVE,
  },
  {
    label: "Active",
    value: FeatureAction.ACTIVE,
  },
  {
    label: "Inactive",
    value: FeatureAction.INACTIVE,
  },
  {
    label: "Approve",
    value: FeatureAction.APPROVE,
  },
  {
    label: "Reject",
    value: FeatureAction.REJECT,
  },
  {
    label: "Clone",
    value: FeatureAction.CLONE,
  },
  {
    label: "Download",
    value: FeatureAction.DOWNLOAD,
  },
];

export enum FeatureType {
  MODULE = "MODULE",
  FEATURE = "FEATURE",
}

export const FeatureTypeOptions = [
  {
    label: "Module",
    value: FeatureType.MODULE,
  },
  {
    label: "Feature",
    value: FeatureType.FEATURE,
  },
];
